<template>
  <div>
    <button class="btn p-0 ml-1" @click="openModal">
      <feather-icon icon="EditIcon" size="18"/>
    </button>

    <b-modal
        v-model="showModal"
        :title="$t('change_invoice_auto_remove_days')"
        :ok-title="$t('save')"
        :cancel-title="$t('cancel')"
        @ok.prevent="handleSave"
    >
      <b-form-group>
        <b-form-input
            v-model.number="days"
            :placeholder="$t('set_invoice_auto_remove_days_placeholder')"
            type="number"
            min="1"
            max="999"
            @input="validate"
        ></b-form-input>
        <div class="mt-1 text-danger" v-if="error">
          {{ $t(error) }}
        </div>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "SetAutoRemoveDaysAdmin",
  props: {
    itemId: { type: [Number, String], required: true },
    currentValue: { type: [Number, null], default: null },
  },
  data() {
    return {
      showModal: false,
      days: null,
      error: "",
    };
  },
  methods: {
    openModal() {
      this.days = this.currentValue ?? null;
      this.showModal = true;
    },

    validate() {
      if (!Number.isInteger(this.days) || this.days < 1 || this.days > 999) {
        this.error = "set_invoice_auto_remove_days_error";
        return false;
      }
      this.error = "";
      return true;
    },

    handleSave() {
      if (!this.validate()) return;
      this.$http.post(`/invoice/admin/save-remove-days-from-admin`, { id: this.itemId, days: this.days }).then(() => {
        this.$emit('updated', this.days);
        this.showModal = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("success"),
            icon: "CheckIcon",
            variant: "success",
          },
        });
      });
    },

  },
};
</script>
